import React from "react";
import theme from "../../central/theme";
import SelectBox from "../../central/SelectBox";

const boxStyle = {
  borderRadius: "4px",
  padding: "8px 12px",
  marginBottom: "6px",
  cursor: "pointer",
  fontWeight: "500",
  color: theme.colors.textPrimary,
  transition: "background-color 0.2s ease",
  width: "100%",
  display: "flex",
  alignItems: "center",
};

const inputStyle = {
  display: "none",
};

const CleanSheetStep = ({ players, appearanceData = {}, onNext, cleanSheet, setCleanSheet }) => {
  return (
    <div>
      <div  style={{
          fontStyle: "italic",
          marginBottom: 8,
          fontSize: "0.9em"
        }}>Did the team keep a <strong>clean sheet</strong>?
      </div>

      <SelectBox
        selected={cleanSheet === true}
        onClick={() => setCleanSheet(true)}
      >
        Yes
      </SelectBox>
      <SelectBox
        selected={cleanSheet === false}
        onClick={() => setCleanSheet(false)}
      >
        No
      </SelectBox>
      <div style={{ marginTop: "20px" }}>

      </div>
    </div>
  );
};

export default CleanSheetStep;